// /src/hooks/useUrlAnalysisScope.js
// react
import { useCallback, useEffect } from 'react';

// components
import useSearchParams from '@/hooks/useStableSearchParams';

export default function useUrlAnalysisScope({
  allowed = ['node', 'seu'],
  fallback = 'node',
  key = 'scope',
} = {}) {
  const [searchParams, setSearchParams] = useSearchParams();

  const raw = searchParams.get(key);
  const scope = allowed.includes(raw) ? raw : fallback;

  // Normalize URL: ensure key exists and is valid
  useEffect(() => {
    // Only normalize if missing/invalid
    if (allowed.includes(raw)) return;

    setSearchParams(
      (prev) => {
        const sp = new URLSearchParams(prev);
        sp.set(key, fallback);
        return sp;
      },
      { replace: true },
    );
  }, [raw, allowed, fallback, key, setSearchParams]);

  const setScope = useCallback(
    (next, { push = false } = {}) => {
      const safe = allowed.includes(next) ? next : fallback;

      setSearchParams(
        (prev) => {
          const sp = new URLSearchParams(prev);
          sp.set(key, safe);
          return sp;
        },
        { replace: !push },
      );
    },
    [allowed, fallback, key, setSearchParams],
  );

  return [scope, setScope];
}
